import { safeLocalStorage } from '@fluidx/utilities';
const OdspDriverManifestCacheStorageKeyPrefix = 'fluidOdspDriverManifestCache_';
//#region Odsp manifest related cache operations
export function getCachedManifestEntryForDeploymentRing(deploymentRing) {
    // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache and prefetch entry
    const cacheEntry = safeLocalStorage()?.getItem(getManifestCacheKey(deploymentRing));
    if (!cacheEntry) {
        return null;
    }
    const parsed = JSON.parse(cacheEntry);
    return parsed;
}
export function cacheManifestEntryForDeploymentRing(manifest, deploymentRing) {
    // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache
    const storage = safeLocalStorage();
    if (!storage) {
        return;
    }
    const manifestWithLastUpdatedTimestamp = { ...manifest, lastUpdatedTime: Date.now() };
    safeLocalStorage()?.setItem(getManifestCacheKey(deploymentRing), JSON.stringify(manifestWithLastUpdatedTimestamp));
}
/**
 * Checks whether ODSP driver caching is enabled
 **/
export function isManifestCachingMechanismEnabled() {
    // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache
    return !!safeLocalStorage();
}
function getManifestCacheKey(deploymentRing) {
    const deploymentRingOrDefault = deploymentRing || 'Prod';
    return OdspDriverManifestCacheStorageKeyPrefix + deploymentRingOrDefault;
}
//#endregion Odsp manifest related cache operations
//#region Prefetch-related cache operations
export function getCachedPrefetchEntryForDeploymentRing(deploymentRing) {
    // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache and prefetch entry
    const cacheEntry = safeLocalStorage()?.getItem(getPrefetchCacheKey(deploymentRing));
    return cacheEntry || null;
}
export function cachePrefetchEntryForDeploymentRing(entryName, deploymentRing) {
    // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache and prefetch entry
    const storage = safeLocalStorage();
    if (!storage) {
        return;
    }
    safeLocalStorage()?.setItem(getPrefetchCacheKey(deploymentRing), entryName);
}
/**
 * Get prefetch key name which is used to compare the driver file name from latest manifest json and the filename we previously prefetched to decide whether or not a new prefetch is required.
 */
function getPrefetchCacheKey(deploymentRing) {
    return getManifestCacheKey(deploymentRing) + '_prefetch';
}
//#endregion Prefetch related cache operations
//# sourceMappingURL=ManifestCacheHelpers.js.map